export const TOTAL_CLIENTS = 'totalClients';
export const TOTAL_WORKERS_WORKING = 'totalWorkersWorking';
export const TOTAL_POSITIONS_OPEN = 'totalPositionsOpen';
export const TOTAL_WORKERS_PER_CLIENT = 'totalWorkersPerClient';
export const TOTAL_ONBOARDING_SUBMISSIONS = 'totalOnboardingSubmissions';
export const DATE_RANGES = 'dateRanges';
